import React, { useState } from 'react';
import AnalyticsFilters from '../components/analytics/AnalyticsFilters';
import KeyInsights from '../components/analytics/KeyInsights';
import SentimentCluster from '../components/analytics/SentimentCluster';
import WordCloud from '../components/analytics/WordCloud';
import CategoryPerformance from '../components/analytics/CategoryPerformance';
import CategoryStatsTable from '../components/analytics/CategoryStatsTable';
import CategoryStatsMatrix from '../components/analytics/CategoryStatsMatrix';
import { livpureMockData } from '../data';
import useCategoryTrend from '../hooks/useCategoryTrend';
import CategoryTrendChart from '../components/analytics/CategoryTrend';

const CategoryInsights = () => {
  const today = new Date();
  const thrityDaysAgo = new Date();
  thrityDaysAgo.setDate(today.getDate() - 30);
  // Filter states
  const [selectedRegion, setSelectedRegion] = useState('global');
  const [selectedCity, setSelectedCity] = useState('');
  const [dateRange, setDateRange] = useState([thrityDaysAgo, today]);
  const [showLocations, setShowLocations] = useState(true);
  const [showProducts, setShowProducts] = useState(true);
  const [showApps, setShowApps] = useState(true);
  const [showNPS, setShowNPs] = useState(true);
  const [isFiltersExpanded, setIsFiltersExpanded] = useState(false);
  const trendData = useCategoryTrend(livpureMockData.reviews, {
    selectedRegion,
    selectedCity,
    dateRange,
    showLocations,
    showProducts,
    showApps
  });
  return (
    <div className="">
      <div className="mb-3">
        <h1 className="text-2xl font-semibold text-gray-800">Category Insights</h1>
        <p className="text-sm text-gray-600 mt-1">
          AI-powered analysis of review categories, sentiment trends, and key topics across platforms
        </p>
      </div>

      {/* Filters Section */}
      <AnalyticsFilters
        regions={livpureMockData.regions}
        selectedRegion={selectedRegion}
        setSelectedRegion={setSelectedRegion}
        selectedCity={selectedCity}
        setSelectedCity={setSelectedCity}
        dateRange={dateRange}
        setDateRange={setDateRange}
        showLocations={showLocations}
        setShowLocations={setShowLocations}
        showProducts={showProducts}
        setShowProducts={setShowProducts}
        showNPS={showNPS}
        setShowNPS={setShowNPs}
        showApps={showApps}
        setShowApps={setShowApps}
        isExpanded={isFiltersExpanded}
        toggleExpand={() => setIsFiltersExpanded(!isFiltersExpanded)}
      />

      <div className="mb-6">
        <CategoryTrendChart data={trendData} />
      </div>

      {/* Key Insights Panel */}
      <div className="mb-6">
        <KeyInsights 
          selectedRegion={selectedRegion}
          selectedCity={selectedCity}
          dateRange={dateRange}
          showLocations={showLocations}
          showProducts={showProducts}
          showApps={showApps}
        />
      </div>

      {/* Category Performance */}
      <div className="bg-white rounded-lg shadow-sm mb-6">
        <CategoryPerformance
          selectedRegion={selectedRegion}
          selectedCity={selectedCity}
          dateRange={dateRange}
          showLocations={showLocations}
          showProducts={showProducts}
          showApps={showApps}
        />
      </div>

       {/* All Category Stats Section with View Toggle */}
       <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-medium text-gray-800">Category Matrix</h2>
        </div>
        
          <CategoryStatsMatrix
            selectedRegion={selectedRegion}
            selectedCity={selectedCity}
            dateRange={dateRange}
            showLocations={showLocations}
            showProducts={showProducts}
            showApps={showApps}
          />
      </div>

       {/* All Category Stats Section with View Toggle */}
       <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-medium text-gray-800">Category Stats</h2>
        </div>
        <CategoryStatsTable
        selectedRegion={selectedRegion}
        selectedCity={selectedCity}
        dateRange={dateRange}
        showLocations={showLocations}
        showProducts={showProducts}
        showApps={showApps}
        />
      </div>

      {/* Analytics Grid Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        {/* Sentiment Cluster */}
        <div className="bg-white rounded-lg shadow-sm p-4">
          <SentimentCluster
            selectedRegion={selectedRegion}
            selectedCity={selectedCity}
            dateRange={dateRange}
            showLocations={showLocations}
            showProducts={showProducts}
            showApps={showApps}
          />
        </div>

        {/* Word Cloud */}
        <div className="bg-white rounded-lg shadow-sm p-4">
          <WordCloud
            selectedRegion={selectedRegion}
            selectedCity={selectedCity}
            dateRange={dateRange}
            showLocations={showLocations}
            showProducts={showProducts}
            showApps={showApps}
          />
        </div>
      </div>
    </div>
  );
};

export default CategoryInsights;